// @flow
import type { State } from 'store/State';
import type { ISocial, Provider } from './ISocial';

export function getSocial(state: State): ISocial {
  return state.user.social;
}

export function getPartialSignInProvider(state: State): Provider | void {
  const social = getSocial(state);
  return social.partialSignInProvider;
}

/** Returns true if the user is partially signed in */
export function isPartiallySignedIn(state: State): boolean {
  return Boolean(getPartialSignInProvider(state));
}



// WEBPACK FOOTER //
// ./src/store/reducers/user/social/selectors.js